// src/Components/VotersList.js
import React from "react";
import { useNavigate } from "react-router-dom";

const VotersList = ({ image, name, designation, voter }) => {
    const navigate = useNavigate();

    const handleDoubleClick = () => {
        console.log("Double-clicked voter:", voter);
        if (!voter || !voter.id) {
            console.error("Voter object or voter.id is missing:", voter);
            return;
        }
        // Navigate to the edit page with an edit flag in the query string and pass the voter object in state.
        navigate(`/VoterRegistration?edit=true`, { state: voter });
    };

    return (
        <div className="flex items-center cursor-pointer" onDoubleClick={handleDoubleClick}>
            {image && (
                <img src={image} alt={name} className="w-10 h-10 rounded-full object-cover" />
            )}
            <div className="ml-4">
                <div className="font-semibold">{name}</div>
                <div className="text-sm text-gray-600">{designation}</div>
            </div>
        </div>
    );
};

export default VotersList;
